import { pushDataLayer } from "../../../Shared/utils/datalayer";
export const pushRdamDataLayer = (data)=>pushDataLayer({
        ...data,
        event: 'events.rdambib'
    });
export const pushLoginEvent = ()=>pushRdamDataLayer({
        category: 'Login',
        action: 'Click',
        label: window.location.pathname
    });
export const pushSiteSearch = (query)=>pushRdamDataLayer({
        category: 'Site search',
        action: query,
        label: window.location.pathname
    });
export const pushNavigationEvent = (label)=>pushRdamDataLayer({
        category: 'Navigation',
        action: label,
        label: window.location.pathname
    });
export const pushActivityInteraction = (activityTitle, clusterTitle)=>pushRdamDataLayer({
        category: 'Activities',
        action: clusterTitle,
        label: activityTitle
    });
export const pushLocationInteraction = (action, label)=>pushRdamDataLayer({
        category: 'Location',
        action,
        label
    });
export const pushMembershipAction = (action)=>pushRdamDataLayer({
        category: 'Membership',
        action,
        label: window.location.pathname
    });
export const pushNewsletterSubscription = (action)=>pushRdamDataLayer({
        category: 'Newsletter',
        action,
        label: window.location.pathname
    });
export const pushContactFormInteraction = (type)=>pushRdamDataLayer({
        category: 'Contact',
        action: type,
        label: window.location.pathname
    });
export const pushTranslateAction = (label)=>pushRdamDataLayer({
        category: 'Translate',
        action: 'change_language',
        label
    });
